import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Broker } from '../../models/api/app-main.model';
import { Broker as DetailBroker } from '../../models/api/broker.model';
import { AppMainService } from './app-main.service';

@Injectable({ providedIn: 'root' })
export class BrokerService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/Broker`;

  private readonly appMainService = inject(AppMainService);

  getBrokers(): Observable<Broker[]> {
    return this.appMainService.getMasterConfig().pipe(map((config) => config.brokers || []));
  }

  getBrokerById(id: number): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/${id}`)
      .pipe(catchError((err) => throwError(() => err)));
  }

  getBrokerMaster(id: number): Observable<DetailBroker> {
    return this.http
      .get<DetailBroker>(`${this.baseUrl}/master/${id}`)
      .pipe(catchError((err) => throwError(() => err)));
  }

  /** Invalidate cache on logout (call from AuthService.clearSession) */
  clearCache(): void {
    this.appMainService.clearCache();
  }
}
